import $ from "jquery";
import swiperSlider from "../swiperSlider/swiperSlider";

const achievement = {
    variables: {
        slider: ".achievements-section__slider",
        url: window.location.href,
    },
    methods: {
        init: function () {
            let swiperConfig = {
                loop: false,
                speed: 1000,
                slidesPerView: 1,
                spaceBetween: 0
            };
            $(achievement.variables.slider).length > 0 &&
                swiperSlider.methods.initializerSwiper(
                    achievement.variables.slider,
                    swiperConfig
                );
            $('.swiper-button-prev').on('click', function(){
                      var title = $(".achievements-section--title").text();
                      var obj = achievement.methods.dataLayerObj(title, "Previous");
                      createDataLayer('List_Scroll_Previous', obj);
                  });
            $('.swiper-button-next').on('click', function(){
                    var title = $(".achievements-section--title").text();
                    var obj = achievement.methods.dataLayerObj(title, "Next");
                    createDataLayer('List_Scroll_Next', obj);
                  });
        },
        dataLayerObj: function (e,buttonName) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : buttonName ? buttonName : '',
                'pageSection' : e ? e.replace(/\n/g, '').trim() : "",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? achievement.variables.url.includes("blog") ? "Blogs" : achievement.variables.url.substring(achievement.variables.url.indexOf(".com/"), achievement.variables.url.lastIndexOf('/')  === ".com") && !achievement.variables.url.substring(achievement.variables.url.indexOf(".com/"), achievement.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
            };
            return obj;
        },
    },
};

$(() => {
    if ($(".achievements-section").length) {
         achievement.methods.init();
    }
});
